(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kcs-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const imageRatio = (image, fallback) => {
      if (image && image.naturalWidth > 0 && image.naturalHeight > 0) {
        return image.naturalWidth / image.naturalHeight;
      }
      return fallback;
    };

    const fitMatchedHeights = (root) => {
      if (!root.classList.contains('kcs-testimonial-carousel--match-heights')) return;

      const targetHeight = Number(root.dataset.matchedHeight || 600);
      const slides = root.querySelectorAll('[data-kcs-slide].is-active');
      const readableMobile = root.classList.contains('kcs-testimonial-carousel--stack-mobile') && mobileQuery.matches;

      if (readableMobile) {
        slides.forEach((slide) => {
          slide.querySelector('.kcs-testimonial-carousel__pair')?.style.removeProperty('--kcs-current-match-height');
        });
        return;
      }

      slides.forEach((slide) => {
        const pair = slide.querySelector('.kcs-testimonial-carousel__pair');
        const frameImage = slide.querySelector('.kcs-testimonial-carousel__frame-image');
        const coverImage = slide.querySelector('.kcs-testimonial-carousel__cover-image');
        if (!pair) return;

        if (window.matchMedia('(max-width: 989px)').matches) {
          const mobileHeight = Math.min(targetHeight, window.innerWidth * 0.72);
          pair.style.setProperty('--kcs-current-match-height', `${Math.floor(mobileHeight)}px`);
          return;
        }

        const styles = getComputedStyle(pair);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const availableWidth = Math.max(0, pair.clientWidth - gap - 2);
        const frameRatio = imageRatio(frameImage, 1103 / 1426);
        const coverRatio = imageRatio(coverImage, 8.5 / 11);
        const combinedRatio = frameRatio + coverRatio;
        const widthLimitedHeight = combinedRatio > 0 ? availableWidth / combinedRatio : targetHeight;
        const fittedHeight = Math.max(260, Math.min(targetHeight, widthLimitedHeight));

        pair.style.setProperty('--kcs-current-match-height', `${Math.floor(fittedHeight)}px`);
      });
    };

    const fitText = (element) => {
      const sectionRoot = element.closest('.kcs-testimonial-carousel');
      const stacksOnMobile = sectionRoot?.classList.contains('kcs-testimonial-carousel--stack-mobile');

      if (stacksOnMobile && mobileQuery.matches) {
        element.style.removeProperty('--kcs-fit-font-size');
        return;
      }

      const min = Number(element.dataset.minFont || 10);
      const max = Number(element.dataset.maxFont || 22);
      let low = min;
      let high = max;
      let best = min;

      element.style.setProperty('--kcs-fit-font-size', `${min}px`);

      for (let index = 0; index < 11; index += 1) {
        const midpoint = (low + high) / 2;
        element.style.setProperty('--kcs-fit-font-size', `${midpoint}px`);

        const fits =
          element.scrollHeight <= element.clientHeight + 1 &&
          element.scrollWidth <= element.clientWidth + 1;

        if (fits) {
          best = midpoint;
          low = midpoint;
        } else {
          high = midpoint;
        }
      }

      element.style.setProperty('--kcs-fit-font-size', `${best.toFixed(2)}px`);
    };

    const initializeCarousel = (root) => {
      if (root.dataset.kcsInitialized === 'true') return;
      root.dataset.kcsInitialized = 'true';

      const slides = Array.from(root.querySelectorAll('[data-kcs-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-kcs-dot]'));
      const prevButton = root.querySelector('[data-kcs-prev]');
      const nextButton = root.querySelector('[data-kcs-next]');
      const status = root.querySelector('[data-kcs-status]');
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const interval = Math.max(3000, Number(root.dataset.interval || 8000));
      const isThemeEditor = Boolean(window.Shopify?.designMode);
      let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer = null;
      let paused = false;

      const fitActiveSlide = () => {
        const activeSlide = slides[currentIndex];
        if (!activeSlide) return;

        window.requestAnimationFrame(() => {
          fitMatchedHeights(root);
          activeSlide.querySelectorAll('[data-kcs-testimonial-fit]').forEach((element) => {
            fitText(element);
          });
        });
      };

      const showSlide = (index, announce = false) => {
        if (slides.length === 0) return;
        currentIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        fitActiveSlide();

        if (announce && status) {
          const author = slides[currentIndex].querySelector('.kcs-testimonial-carousel__author')?.textContent?.trim();
          status.textContent = author
            ? `Showing testimonial ${currentIndex + 1} of ${slides.length}, ${author.replace(/^—\s*/, '')}.`
            : `Showing testimonial ${currentIndex + 1} of ${slides.length}.`;
        }
      };

      const stopTimer = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const startTimer = () => {
        stopTimer();
        if (!autoplayEnabled || slides.length < 2 || isThemeEditor || reducedMotionQuery.matches || paused) return;
        timer = window.setInterval(() => showSlide(currentIndex + 1, false), interval);
      };

      const restartTimer = () => {
        stopTimer();
        startTimer();
      };

      prevButton?.addEventListener('click', () => {
        showSlide(currentIndex - 1, true);
        restartTimer();
      });

      nextButton?.addEventListener('click', () => {
        showSlide(currentIndex + 1, true);
        restartTimer();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          showSlide(Number(dot.dataset.index || 0), true);
          restartTimer();
        });
      });

      root.addEventListener('mouseenter', () => {
        paused = true;
        stopTimer();
      });

      root.addEventListener('mouseleave', () => {
        paused = false;
        startTimer();
      });

      root.addEventListener('focusin', () => {
        paused = true;
        stopTimer();
      });

      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) {
          paused = false;
          startTimer();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopTimer();
        } else {
          startTimer();
        }
      });

      reducedMotionQuery.addEventListener?.('change', startTimer);
      mobileQuery.addEventListener?.('change', fitActiveSlide);

      root.querySelectorAll('.kcs-testimonial-carousel__frame-image, .kcs-testimonial-carousel__cover-image').forEach((image) => {
        if (!image.complete) {
          image.addEventListener('load', fitActiveSlide, { once: true });
        }
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(fitActiveSlide);
        resizeObserver.observe(root);
        root.kcsResizeObserver = resizeObserver;
      }

      root.kcsShowSlide = showSlide;
      showSlide(currentIndex, false);
      startTimer();
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-kcs-carousel]').forEach(initializeCarousel);
    };

    const initializeAfterFonts = () => {
      initialize();
      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          document.querySelectorAll('[data-kcs-carousel] .is-active [data-kcs-testimonial-fit]').forEach(fitText);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAfterFonts);
    } else {
      initializeAfterFonts();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-kcs-slide]');
      const root = slide?.closest('[data-kcs-carousel]');
      if (slide && root?.kcsShowSlide) {
        root.kcsShowSlide(Number(slide.dataset.index || 0), false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
